/** @jsxImportSource @emotion/react */
import TextField from "@mui/material/TextField";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import PropTypes from "prop-types";
import { TODAY } from "../../util/dateHelper";
import {
  convert_DateFns_To_Luxon_for_Station_TimeZone_at_Midnight,
  convert_Luxon_To_DateFns,
} from "../../util/dateTimeFormatter";
import { makeStyles } from "@mui/styles";
import { useSelector } from "react-redux";
import { selectStationFilter } from "../../slices/userSession/userSessionSlice";

const useStyles = makeStyles((theme) => ({
  datePickerRoot: {
    "& .MuiOutlinedInput-input": {
      cursor: "pointer",
    },
    "& .MuiSvgIcon-root": {
      display: "none !important",
    },
  },
}));

const StarsDatePicker = (props) => {
  const classes = useStyles();
  const stationFilter = useSelector(selectStationFilter);

  return (
    <MobileDatePicker
      label={props.label}
      value={convert_Luxon_To_DateFns(props.date)}
      onChange={(date, currentString) => {
        if (date !== null) {
          if (!currentString || (currentString.length === 10 && date.toString() !== "Invalid Date")) {
            const convertedDate = convert_DateFns_To_Luxon_for_Station_TimeZone_at_Midnight(date, stationFilter);
            props.onChange(convertedDate);
          }
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          error={props.dateErrors !== ""}
          helperText={props.dateErrors}
          fullWidth={props.fullWidth}
        />
      )}
      className={`${props.className} ${classes.datePickerRoot}`}
      inputFormat={props.inputFormat || "iii MMM dd, yyyy"}
      minDate={props.minDate}
      maxDate={props.maxDate}
      showDaysOutsideCurrentMonth={true}
      showToolbar={true}
      orientation="portrait"
      toolbarPlaceholder={
        props.toolbarPlaceholder ||
        TODAY(stationFilter).toLocaleString({ weekday: "short", month: "short", day: "2-digit" })
      }
      closeOnSelect={true}
      defaultCalendarMonth={props.defaultCalendarMonth}
      shouldDisableDate={props.shouldDisableDate}
      disabled={props.isReadOnly}
    />
  );
};

StarsDatePicker.propTypes = {
  label: PropTypes.string.isRequired,
  date: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  dateErrors: PropTypes.string.isRequired,
  minDate: PropTypes.string,
  maxDate: PropTypes.string,
  className: PropTypes.string,
  inputFormat: PropTypes.string,
  fullWidth: PropTypes.bool,
  defaultCalendarMonth: PropTypes.object,
  shouldDisableDate: PropTypes.func,
  isReadOnly: PropTypes.bool,
  toolbarPlaceholder: PropTypes.string,
};

export default StarsDatePicker;
